var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("本年度实收明细")])
}
var staticRenderFns = []

export { render, staticRenderFns }